export default __webpack_public_path__ + "static/blog-b7ec6b69af8e27633348f7401b9b5d2d.jpg";